import axios from 'axios';
import { Config } from '../config/config';
// Import types from the service layer
import { TrainingRun, Dataset, Configuration } from '../service/trainingManagementService';

// TODO: Define interfaces for Configuration, Dataset, TrainingRun based on finalized schema

// Fix: Handle the case when Config.apiRoot does or doesn't include '/api'
const API_URL = Config.apiRoot.endsWith('/api') 
  ? Config.apiRoot
  : `${Config.apiRoot}/api`;

// Define backend endpoint paths (ensure these match your backend implementation)
const CONFIG_ENDPOINT = `${API_URL}/training-management/configuration`;
const DATASETS_ENDPOINT = `${API_URL}/training-management/datasets`;
const RUNS_ENDPOINT = `${API_URL}/training-management/runs`;
// REMOVED SOURCES_ENDPOINT as it's replaced by the one below
// const SOURCES_ENDPOINT = `${API_URL}/training-management/sources`; 
// CORRECTED Endpoint for structured account/camera info
const ACCOUNT_CAMERAS_ENDPOINT = `${API_URL}/training-management/account-camera-info`;

const getToken = () => {
  const token = localStorage.getItem('token');
  if (!token) {
    // Consider throwing an error or handling unauthorized state more robustly
    console.error('No authentication token found.');
    throw new Error('Authentication token not found'); 
  }
  return token;
};

// Removed mock state variables (mockActiveRuns, mockRunCounter)

export const trainingManagementApi = {
  async getConfiguration(): Promise<Configuration> {
    console.log(`[API] GET ${CONFIG_ENDPOINT}`);
    const token = getToken();
    const response = await axios.get(CONFIG_ENDPOINT, {
      headers: { 'Authorization': `Bearer ${token}` }
    });
    // Assuming backend nests data under a 'data' key, adjust if needed
    return response.data.data || response.data; 
  },

  // REMOVED updateConfiguration as it's not used for start/stop anymore

  async startNewTrainingRun(modelType: string, datasetId: string, parameters: any): Promise<TrainingRun> {
    console.log(`[API] POST ${RUNS_ENDPOINT}`, { modelType, datasetId, parameters });
    const token = getToken();
    const response = await axios.post(RUNS_ENDPOINT, 
      { modelType, datasetId, parameters }, 
      { headers: { 
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
         }
      }
    );
    return response.data.data || response.data; // Return the newly created run document
  },

  async requestStopTrainingRun(runId: string): Promise<{ message: string }> {
    console.log(`[API] POST ${RUNS_ENDPOINT}/${runId}/stop`);
    const token = getToken();
    const response = await axios.post(`${RUNS_ENDPOINT}/${runId}/stop`, {}, {
      headers: { 
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
         }
    });
    return response.data; // e.g., { message: "Stop request received" }
  },

  async getDatasets(): Promise<Dataset[]> {
    console.log(`[API] GET ${DATASETS_ENDPOINT}`);
    const token = getToken();
    const response = await axios.get(DATASETS_ENDPOINT, {
        headers: { 'Authorization': `Bearer ${token}` }
    });
     // Return actual data now that the endpoint exists
     return response.data || []; // Assuming backend returns array directly
  },

  async getAccountCameraInfo(): Promise<any[]> {
    console.log(`[API] GET ${ACCOUNT_CAMERAS_ENDPOINT}`);
    const token = getToken();
    const response = await axios.get(ACCOUNT_CAMERAS_ENDPOINT, {
        headers: { 'Authorization': `Bearer ${token}` }
    });
    // Assuming backend returns array of accounts with populated cameras
    return response.data || []; 
  },
  
  async createDataset(name: string, sources: string[]): Promise<{ message: string; datasetId: string; status: string }> {
       console.log(`[API] POST ${DATASETS_ENDPOINT}`, { name, sources });
       const token = getToken();
       const response = await axios.post(DATASETS_ENDPOINT, 
           { name, sources }, 
           { headers: { 
               'Authorization': `Bearer ${token}`,
               'Content-Type': 'application/json'
              }
           }
       );
       // Return the response from the backend (e.g., { message: "...", datasetId: "...", status: "CREATING" })
       return response.data;
  },

  async getActiveTrainingRuns(): Promise<TrainingRun[]> {
    console.log(`[API] GET ${RUNS_ENDPOINT}?status=running,pending,starting,stopping`);
    const token = getToken();
    const response = await axios.get(RUNS_ENDPOINT, {
        params: { status: 'running,pending,starting,stopping' },
        headers: { 'Authorization': `Bearer ${token}` }
    });
    return response.data.data || response.data || []; 
  },
  
  async getTrainingRunHistory(limit: number = 50, skip: number = 0): Promise<TrainingRun[]> {
    console.log(`[API] GET ${RUNS_ENDPOINT}?limit=${limit}&skip=${skip}`);
    const token = getToken();
    const response = await axios.get(RUNS_ENDPOINT, {
        params: { 
            limit: limit, 
            skip: skip, 
        }, 
        headers: { 'Authorization': `Bearer ${token}` }
    });
    return response.data.data || response.data || [];
  }
}; 